import styled from "styled-components";

export const MyChip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 28px;
  background: #4d9fc4;
  border-radius: 24px;
  margin-right: 5px;
  margin-top: -4px;
  color: white;
`;

export const ChipText = styled.div`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding-left: 12px;
  padding-right: 12px;
  white-space: nowrap;
`;
